import React from 'react';
import Hero from './Hero';
import Quiz from './Quiz';

const Home = () => {
    return (
        <div>
            <Hero></Hero>
            <Quiz></Quiz>
        </div>
    );
};

export default Home;